import React from 'react';
import { Link } from 'react-router-dom';

const Categories = (props) => {
    if (props.user != null && (parseInt(props.user.uth_type) === 5 || parseInt(props.user.uth_type) === 6)) {
        return (
            <div className="categories-container">
                <div className="categories-row">
                    <div className="category">
                        <Link to="/product/7"><div className="image apparel"></div></Link>
                        <div className="title">
                            <div className="name">Apparel</div>
                            <div className="button-container">
                                <Link to="/product/7"><button>Select</button></Link>
                            </div>
                        </div>
                    </div>
                    {/* <div className="category">
                        <Link to="/department/8/377"><div className="image promotional"></div></Link>
                        <div className="title">
                            <div className="name">Promotional</div>
                            <div className="button-container">
                                <Link to="/department/8/377"><button>Select</button></Link>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    } else if (props.user != null && parseInt(props.user.uth_type) === 4) {
        return (
            <div className="categories-container">
                <div className="categories-row">
                    <div className="category">
                        <Link to="/product/7"><div className="image apparel"></div></Link>
                        <div className="title">
                            <div className="name">Apparel</div>
                            <div className="button-container">
                                <Link to="/product/7"><button>Select</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // let displayNewCards = false;
    // if (props.user.username === 'hugh.admin' || props.user.username === 'utdemo') {
    //     displayNewCards = true;
    // }

    return (
        <div className="categories-container">
            <div className="categories-row">
                <div className="category">
                    <Link to="/product/1"><div className="image cards-260924"></div></Link>
                    <div className="title">
                        <div className="name">Cards</div>
                        <div className="button-container">
                            <Link to="/product/1"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/17"><div className="image pocket-folders-12-28-2023"></div></Link>
                    <div className="title">
                        <div className="name">Pocket Folders</div>
                        <div className="button-container">
                            <Link to="/product/17"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/2"><div className="image letterheads"></div></Link>
                    <div className="title">
                        <div className="name">Stationery Letterheads</div>
                        <div className="button-container">
                            <Link to="/product/2"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/3"><div className="image envelopes"></div></Link>
                    <div className="title">
                        <div className="name">Stationery Envelopes</div>
                        <div className="button-container">
                            <Link to="/product/3"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="categories-row">
                <div className="category">
                    <Link to="/product/21"><div className="image catalog-envelopes"></div></Link>
                    <div className="title">
                        <div className="name">Catalog Envelopes</div>
                        <div className="button-container">
                            <Link to="/product/21"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/4"><div className="image notecards"></div></Link>
                    <div className="title">
                        <div className="name">Notecards</div>
                        <div className="button-container">
                            <Link to="/product/4"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/19"><div className="image holiday"></div></Link>
                    <div className="title">
                        <div className="name">Seasonal Items</div>
                        <div className="button-container">
                            <Link to="/product/19"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/18"><div className="image notepads"></div></Link>
                    <div className="title">
                        <div className="name">Notepads</div>
                        <div className="button-container">
                            <Link to="/product/18"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="categories-row">
                <div className="category">
                    <Link to="/template/18/2"><div className="image p18-t2"></div></Link>
                    <div className="title">
                        <div className="name">Emergency/Downtime Prescription Pad</div>
                        <div className="button-container">
                            <Link to="/template/18/2"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/5"><div className="image forms"></div></Link>
                    <div className="title">
                        <div className="name">Forms</div>
                        <div className="button-container">
                            <Link to="/product/5"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/department/16/419">
                        <div className="image" style={{
                            backgroundImage: 'url("https://ac-ut-health.s3.amazonaws.com/brochures-images/New-privacy-poster-24-08-2022.jpg")',
                            backgroundSize: '72%',
                            backgroundColor: '#dadce0',
                            backgroundRepeat: 'no-repeat',
                        }}></div>
                    </Link>
                    <div className="title">
                        <div className="name">Legal Notices</div>
                        <div className="button-container">
                            <Link to="/department/16/419"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                {/* <div className="category">
                    <Link to="/product/6"><div className="image covid"></div></Link>
                    <div className="title">
                        <div className="name">COVID-19</div>
                        <div className="button-container">
                            <Link to="/product/6"><button>Select</button></Link>
                        </div>
                    </div>
                </div> */}
                <div className="category">
                    <Link to="/product/7"><div className="image apparel"></div></Link>
                    <div className="title">
                        <div className="name">Adult Apparel</div>
                        <div className="button-container">
                            <Link to="/product/7"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="categories-row">
                <div className="category">
                    <Link to="/department/8/377"><div className="image promotional"></div></Link>
                    <div className="title">
                        <div className="name">Promotional</div>
                        <div className="button-container">
                            <Link to="/department/8/377"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/department/16/412"><div className="image brochures"></div></Link>
                    <div className="title">
                        <div className="name">Marketing Collateral</div>
                        <div className="button-container">
                            <Link to="/department/16/412"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/14"><div className="image my-uthealth-new-august2023"></div></Link>
                    <div className="title">
                        <div className="name">MyUTHealth Houston</div>
                        <div className="button-container">
                            <Link to="/product/14"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/nrc/1"><div className="image nrc-health-new"></div></Link>
                    <div className="title">
                        <div className="name">NRC Health</div>
                        <div className="button-container">
                            <Link to="/nrc/1"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                {/* <div className="category">
                    <Link to="/department/13/405"><div className="image clearance-new"></div></Link>
                    <div className="title">
                        <div className="name">Clearance</div>
                        <div className="button-container">
                            <Link to="/department/13/405"><button>Select</button></Link>
                        </div>
                    </div>
                </div> */}
            </div>
            <div className="categories-row">
                <div className="category">
                    <Link to="/product/22"><div className="image clinical-signage"></div></Link>
                    <div className="title">
                        <div className="name">Clinical Signage</div>
                        <div className="button-container">
                            <Link to="/product/22"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Categories;
